import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiHandlerService } from '../../core/services/apiCall.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
// import { LeftStorageNavComponent } from '../left-storage-nav/left-storage-nav.component';

@Component({
  selector: 'app-no-compatible-devices',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './no-compatible-devices.component.html',
  styleUrl: './no-compatible-devices.component.scss'
})
export class NoCompatibleDevicesComponent  implements OnInit{
  @Output() changeonBackCLick = new EventEmitter<boolean>();
  deviceLoader: boolean = true;
  @Input() activePlan: any = [];

constructor(private service: ApiHandlerService,
  private toastr: ToastrService,){
  
}

  ngOnInit(): void {
    setTimeout(() => {
      this.deviceLoader= false;

    }, 500);
  }

  onClickBack(backProp: boolean){
    this.changeonBackCLick.emit(backProp);

  }

  onClickDisableAutoRenew(){   
    const idAndModels = this.activePlan?.subscriptionDetails?.association?.devices?.map((device: any) => ({
      id: device?.id,
      device_model_id: device?.device_model_id ?? device?.model,
      channels: [this.activePlan?.plan?.details?.association?.channels]
    }));

    const data = {
    association: {
      devices: idAndModels,
      user: this.activePlan?.subscriptionDetails?.association?.user,
    },
    plan: this.activePlan?.plan,
    subscriptionId: this.activePlan?.subscriptionDetails?.id,
  };

  this.service.Put(`subscriptions/autorenewalanddisable`, data).subscribe(
    (data:any) =>{
      if(data?.code == 10000){
        this.toastr.success('Successfully  Disable Auto Renewal');
      }
    },
    (error: any) => {
      this.toastr.error('Failed  Disable Auto Renewal');

    }
  )

  }
  disableAutoRenew(){
 
  }
}
